import Ship from "@/model/Ship"
import ParametricTableService from "../ParametricTableService"
import utils from "@/utils/configuration/config.js"
import {ETSArrayData} from "@/model/Neobuq/NeobuqArrayData"

class ETSService{

    private static instance: ETSService;

    private constructor() {}

    public static getInstance(): ETSService {
        if (!ETSService.instance) {
            ETSService.instance = new ETSService();
        }

        return ETSService.instance;
    }

    public calc_ets_values(ship: Ship, data: Array<ETSArrayData>, priceEUA: number, optionGWP: string){

        let aux_anual_emissions = 0
        let aux_emission_rights = 0
        let aux_EUA_costs = 0
        let GWPValues = {}
        //ship.baseETS = []
        const arrayETS = [{}]

        //obtenemos los valores de GWP a usar
        const parametricTables = ParametricTableService.getInstance().getParametricTable(
            utils.config.firebaseConfig.parametricVersion
        )
        
        if(optionGWP == "RED"){
            GWPValues = parametricTables["GWPvaluesN1"][0]
        }else if(optionGWP == "IPCC"){
            GWPValues = parametricTables["GWPvaluesN2"][0]
        }

        //por cada año
        for(let i=0; i< data.length; i++){

           let sumatorio = 0
            
            if(data[i].year == "2023" || data[i].year == "2024" || data[i].year == "2025"){

                //tenemos que hacer sumatorio de los combustibles
                for(let j=0; j < ship.fuelConsumption.length; j++){
                    //primero hacemos sumatorio de FC por el CF del gas (CO2, N2O o CH4)
                    const fc = ship.fuelConsumption[j].consumption
                    const cfs_CO2 = ship.fuelConsumption[j].fuel.cfs[0]["CO2"]

                    sumatorio = sumatorio + (fc * cfs_CO2)
                }

                //multiplicamos el sumatorio por el GWP del CO2, que para estos 2 años sólo aplicamos este
                aux_anual_emissions = Number((sumatorio * GWPValues["CO2"]).toFixed(2))

                if(data[i].year == "2024"){
                    aux_emission_rights = Math.trunc(aux_anual_emissions * 0.4)
                    aux_EUA_costs = Number((aux_emission_rights * priceEUA).toFixed(2))
                }else if(data[i].year == "2025"){
                    aux_emission_rights = Math.trunc(aux_anual_emissions * 0.7)
                    aux_EUA_costs = Number((aux_emission_rights * priceEUA).toFixed(2))
                }
                else{
                    aux_emission_rights = 0
                    aux_EUA_costs = 0
                }

            }else{

                let sumatorio_aux = 0
                
                //sabemos que hay 3 gases fijos con los que trabajar (CO2, CH4 y N2O)
                for(let k=0; k < 3; k++){

                    let GWP_gas = 0

                    //cogemos el valor GWP correspondiente al gas en el que estamos
                    switch(k){
                        case 0:
                            GWP_gas = GWPValues["CO2"]
                            break;
                        case 1:
                            GWP_gas = GWPValues["CH4"]
                            break;
                        case 2:
                            GWP_gas = GWPValues["N2O"]
                            break;
                    }

                    //console.log("GWP_gas")
                    //console.log(GWP_gas)

                    sumatorio_aux = 0

                    for(let j=0; j < ship.fuelConsumption.length; j++){
                        //primero hacemos sumatorio de FC por el CF del gas (CO2, N2O o CH4)
                        const fc = ship.fuelConsumption[j].consumption
                        let cfs_gas = 0
                        
                        switch(k){
                            case 0:
                                cfs_gas = ship.fuelConsumption[j].fuel.cfs[0]["CO2"]
                                break;
                            case 1:
                                cfs_gas = ship.fuelConsumption[j].fuel.cfs[0]["CH4"]
                                break;
                            case 2:
                                cfs_gas = ship.fuelConsumption[j].fuel.cfs[0]["N2O"]
                                break;
                        }

                        //console.log("cfs_gas: " + cfs_gas)
                        sumatorio_aux = sumatorio_aux + (fc * cfs_gas)
                        //console.log("ship.fuelConsumption[" + j + "] - sumatorio_aux: " + sumatorio_aux)

                    }

                    sumatorio = sumatorio + (sumatorio_aux * GWP_gas)
                    //console.log("Gas " + k + " - sumatorio: " + sumatorio)
                }

                aux_anual_emissions = Number(sumatorio.toFixed(2))
                //console.log("aux_anual_emissions")
                //console.log(aux_anual_emissions)
                aux_emission_rights = Math.trunc(aux_anual_emissions * 1)
                aux_EUA_costs = Number((aux_emission_rights * priceEUA).toFixed(2))
            }

            const auxETS = {year : data[i].year, anualEmissions : aux_anual_emissions, 
                                emissionRights: aux_emission_rights, costEUA: aux_EUA_costs}
            //guardamos el resultado
            //ship.baseETS.push(auxETS)
            arrayETS.push(auxETS)
        }

        ship.dataForETS = {priceEUA: priceEUA, selectedGWPOPtion: optionGWP}
        arrayETS.splice(0,1)
        return arrayETS
    }

}

export default ETSService;